import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsFindBy } from 'services/WService';
import { Autocomplete } from '@material-ui/lab';

export default function ModalActivityDetail2(props) {
  const activityDetail2 = props.model;
  const { id } = props;
  const [dataChanging, setDataChanging] = useState([]);
  const [numbers, setNumbers] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listNumbers() {
    let response = await wsFindBy('report/contact-report', { state: 'A' });
    if (response.success) setNumbers(response.data);
  }

  useEffect(() => {
    if (activityDetail2.open) {
      listNumbers();
    }
  }, [activityDetail2.open]);

  useEffect(() => {
    if (numbers.length > 0 && activityDetail2.number_report_id) {
      handleChange("number_report_id", String(activityDetail2.number_report_id));
    }
  },[numbers])

  return (
    <Modal
      title="Nuevo contacto para archivo"
      model={activityDetail2}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="report/file-number-report"
      state
      dataForce={{
        file_report_id: id,
        number_report_id: dataChanging.number_report_id,
      }}
    >
      <Autocomplete
        disableClearable
        options={numbers}
        getOptionLabel={(item) =>
          item.phone
            ? `Contacto: ${item.grupo_description} (Número: ${item.phone})`
            : `Grupo: ${item.grupo_description}`
        }
        renderInput={(params) => (
          <TextField {...params} label="Contactos" margin="normal" fullWidth />
        )}
        onChange={(e, item) => {
          handleChange('number_report_id', item?.id);
        }}
        value={
          numbers.find((number) => String(number.id) === String(dataChanging.number_report_id)) ||
          null
        }
        style={{ flexGrow: 1, marginRight: '10px' }}
      />
    </Modal>
  );
}
